import React from 'react';
import { Button, Flex, Typography } from 'antd';
import WithMainContainer from '@/components/layout';
import WIthHelpContainer from '@/utils/hocs/WithHelpContainer';
import HelpCollapse from '@/components/HelpPage/HelpCollapse';
import { useStores } from '@/utils/hooks/useStores';
import QuestionButton from '@/components/HelpPage/QuestionButton';
import hp from '../HelpPage.module.scss';
import g from '@/general.module.scss';
import Image from 'next/image';

import image_help_customers_1 from '/public/static/images/image_help_customers_1.svg';
import image_help_customers_2 from '/public/static/images/image_help_customers_2.svg';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import HeadService from '@/utils/services/HeadService';

function HelpCustomersPage() {
    const {
        modalsStore: { openLoginForm, openRegisterForm },
    } = useStores();
    const LOCALIZATION = useLocalization();
    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild('Информация для покупателей', '/help/customers')}
            <Flex
                vertical
                className={hp.container_body}
            >
                <Typography.Text className={`text-24-500`}>
                    {LOCALIZATION.pages.help.buyers.title}
                </Typography.Text>
                <HelpCollapse
                    items={[
                        {
                            key: '0',
                            label: LOCALIZATION.pages.help.buyers.general.title,
                            children: (
                                <Flex vertical>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.general.text1}{' '}
                                        <Button
                                            className={g.button_text}
                                            type={'text'}
                                            onClick={() => {
                                                openRegisterForm();
                                            }}
                                        >
                                            {LOCALIZATION.pages.help.buyers.general.text2}
                                        </Button>
                                        /
                                        <Button
                                            onClick={() => {
                                                openLoginForm();
                                            }}
                                            className={g.button_text}
                                            type={'text'}
                                        >
                                            {LOCALIZATION.pages.help.buyers.general.text3}
                                        </Button>{' '}
                                        {LOCALIZATION.pages.help.buyers.general.text4}
                                    </span>
                                </Flex>
                            ),
                        },
                        {
                            key: '1',
                            label: LOCALIZATION.pages.help.buyers.marketplace.title,
                            children: (
                                <Flex vertical>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.marketplace.text1}{' '}
                                        <span style={{ color: '#8A24F8' }}>
                                            {LOCALIZATION.pages.help.buyers.marketplace.text2}
                                        </span>
                                        .
                                    </span>
                                    <span>{LOCALIZATION.pages.help.buyers.marketplace.text3}</span>
                                </Flex>
                            ),
                        },
                        {
                            key: '2',
                            label: LOCALIZATION.pages.help.buyers.lkEntrance.title,
                            children: (
                                <Flex
                                    vertical
                                    gap={'4px'}
                                >
                                    <span>
                                        <span style={{ fontWeight: '500' }}>
                                            {LOCALIZATION.pages.help.buyers.lkEntrance.text1}
                                        </span>
                                        {LOCALIZATION.pages.help.buyers.lkEntrance.text2}
                                    </span>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkEntrance.text3}
                                        <span style={{ fontWeight: '500' }}>
                                            {LOCALIZATION.pages.help.buyers.lkEntrance.text4}
                                        </span>
                                        ».
                                        {LOCALIZATION.pages.help.buyers.lkEntrance.text5}
                                    </span>
                                </Flex>
                            ),
                        },
                        {
                            key: '3',
                            label: LOCALIZATION.pages.help.buyers.lkAccData.title,
                            children: (
                                <Flex vertical>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkAccData.text1}{' '}
                                        <span style={{ fontWeight: '500' }}>
                                            {LOCALIZATION.pages.help.buyers.lkAccData.text2}
                                        </span>
                                        {LOCALIZATION.pages.help.buyers.lkAccData.text3}
                                    </span>
                                </Flex>
                            ),
                        },
                        {
                            key: '4',
                            label: LOCALIZATION.pages.help.buyers.lkHowToMakeOrder.title,
                            children: (
                                <Flex vertical>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkHowToMakeOrder.text1}{' '}
                                        <span style={{ color: '#8A24F8' }}>
                                            {LOCALIZATION.pages.help.buyers.lkHowToMakeOrder.text2}
                                        </span>
                                        .
                                    </span>
                                    <Flex
                                        vertical
                                        gap={'24px'}
                                    >
                                        <Flex vertical>
                                            <span style={{ fontWeight: '500' }}>
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text3
                                                }
                                            </span>
                                            <span>
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text4
                                                }
                                            </span>
                                        </Flex>
                                        <Image
                                            style={{ aspectRatio: '510 / 1222', width: '100%' }}
                                            src={image_help_customers_1}
                                            sizes={'100%'}
                                            width={0}
                                            height={0}
                                            alt={''}
                                        />
                                        <Flex vertical>
                                            <span style={{ fontWeight: '500' }}>
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text5
                                                }
                                            </span>
                                            <span>
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text6
                                                }{' '}
                                                <span style={{ color: '#8A24F8' }}>
                                                    {
                                                        LOCALIZATION.pages.help.buyers
                                                            .lkHowToMakeOrder.text7
                                                    }
                                                </span>
                                                .
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text8
                                                }{' '}
                                                <span style={{ color: '#8A24F8' }}>
                                                    {
                                                        LOCALIZATION.pages.help.buyers
                                                            .lkHowToMakeOrder.text9
                                                    }
                                                </span>
                                                .
                                            </span>
                                        </Flex>
                                        <Image
                                            style={{ aspectRatio: '283 / 1222', width: '100%' }}
                                            src={image_help_customers_2}
                                            sizes={'100%'}
                                            width={0}
                                            height={0}
                                            alt={''}
                                        />
                                        <Flex vertical>
                                            <span style={{ fontWeight: '500' }}>
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text10
                                                }
                                            </span>
                                            <span>
                                                {
                                                    LOCALIZATION.pages.help.buyers.lkHowToMakeOrder
                                                        .text11
                                                }{' '}
                                                <span style={{ color: '#8A24F8' }}>
                                                    {
                                                        LOCALIZATION.pages.help.buyers
                                                            .lkHowToMakeOrder.text12
                                                    }
                                                </span>
                                                .
                                            </span>
                                        </Flex>
                                    </Flex>
                                </Flex>
                            ),
                        },
                        {
                            key: '5',
                            label: LOCALIZATION.pages.help.buyers.lkMyOrder.title,
                            children: (
                                <Flex vertical>
                                    <span>{LOCALIZATION.pages.help.buyers.lkMyOrder.text1}</span>
                                    <span>{LOCALIZATION.pages.help.buyers.lkMyOrder.text2}</span>
                                    <ul>
                                        <li>{LOCALIZATION.pages.help.buyers.lkMyOrder.text3}</li>
                                        <li>{LOCALIZATION.pages.help.buyers.lkMyOrder.text4}</li>
                                        <li>{LOCALIZATION.pages.help.buyers.lkMyOrder.text5}</li>
                                        <li>{LOCALIZATION.pages.help.buyers.lkMyOrder.text6}</li>
                                    </ul>
                                    <span>{LOCALIZATION.pages.help.buyers.lkMyOrder.text7}</span>
                                </Flex>
                            ),
                        },
                        {
                            key: '6',
                            label: LOCALIZATION.pages.help.buyers.lkCompareProducts.title,
                            children: (
                                <Flex
                                    vertical
                                    gap={'12px'}
                                >
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkCompareProducts.text1}
                                    </span>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkCompareProducts.text2}
                                    </span>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkCompareProducts.text3}
                                    </span>
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkCompareProducts.text4}
                                    </span>
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                </Flex>
                            ),
                        },
                        {
                            key: '7',
                            label: LOCALIZATION.pages.help.buyers.lkFavorites.title,
                            children: (
                                <Flex
                                    vertical
                                    gap={'12px'}
                                >
                                    <span>{LOCALIZATION.pages.help.buyers.lkFavorites.text1}</span>
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                    <span>{LOCALIZATION.pages.help.buyers.lkFavorites.text2}</span>
                                    <span>{LOCALIZATION.pages.help.buyers.lkFavorites.text3}</span>
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                    <span>{LOCALIZATION.pages.help.buyers.lkFavorites.text4} </span>
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                </Flex>
                            ),
                        },
                        {
                            key: '8',
                            label: LOCALIZATION.pages.help.buyers.lkManufacturingRepairRequests
                                .title,
                            children: (
                                <Flex vertical>
                                    {
                                        LOCALIZATION.pages.help.buyers.lkManufacturingRepairRequests
                                            .text1
                                    }
                                </Flex>
                            ),
                        },
                        {
                            key: '9',
                            label: LOCALIZATION.pages.help.buyers.lkNotifications.title,
                            children: (
                                <Flex vertical>
                                    <span>
                                        {LOCALIZATION.pages.help.buyers.lkNotifications.text1}
                                    </span>
                                </Flex>
                            ),
                        },
                        {
                            key: '10',
                            label: LOCALIZATION.pages.help.buyers.productCharacteristics.title,
                            children: (
                                <Flex
                                    vertical
                                    gap={'12px'}
                                >
                                    <span>
                                        {
                                            LOCALIZATION.pages.help.buyers.productCharacteristics
                                                .text1
                                        }
                                    </span>
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                    <Image
                                        src={''}
                                        alt={''}
                                        width={0}
                                        height={0}
                                        sizes={'100%'}
                                    />
                                </Flex>
                            ),
                        },
                        {
                            key: '11',
                            label: LOCALIZATION.pages.help.buyers.feedback.title,
                            children: (
                                <Flex vertical>
                                    <span>{LOCALIZATION.pages.help.buyers.feedback.text1} </span>
                                </Flex>
                            ),
                        },
                    ]}
                />
                <QuestionButton />
            </Flex>
        </>
    );
}

export default WithMainContainer(WIthHelpContainer(HelpCustomersPage));
